angular.module("questionarioAdv.module")
    .component("esecutoriForzati", {
        templateUrl: "ng/components/questionarioAdv/esecutoriForzati/esecutoriForzati.view.html",
        bindings: {
            model: "=",
            startQuestionario: '<'
        },
        controllerAs: 'esecutoriForzatiCtrl',
        controller: EsecutoriForzati
    })

function EsecutoriForzati($financialApiService, $rootScope) {

    var self = this;

    self.$onInit = () => {

    }


    self.removeEsecutore = (esecutore) => {

        self.model = self.model.filter(x => {
            return x.ndg != esecutore.ndg;
        })
    }


    self.addEsecutori = () => {
        if (checkIfPrent()) {
            $rootScope.$broadcast('addAlert', {
                text: 'PF_ALREADY_ADDED'
            });
            self.ndgEsecutore = null;
            return
        }
        self.loaderSearchEsecutori = true;
        $financialApiService.searchSubject(self.ndgEsecutore, "G")
            .then(response => {
                if (response.ndg && response.ragSoc) {
                    var temp = {
                        ndg: response.ndg,
                        ragioneSociale: response.ragSoc
                    }

                    self.model.push(temp);
                }
                self.loaderSearchEsecutori = false;
                self.ndgEsecutore = null;
            })
            .catch(error => {
                console.log(error)
                self.loaderSearchEsecutori = false;
                self.ndgEsecutore = null;
            })




    }

    var checkIfPrent = () => {

        return self.model.some(x => {
            return x.ndg == self.ndgEsecutore
        })
    }
}